import React from 'react';
import { ENTITY_FIELD_SLOT_WIDTH_IN_PX } from '../../constants/design';

const EntityFieldSlotSpacer = () => (
  <div style={{ width: ENTITY_FIELD_SLOT_WIDTH_IN_PX, height: '100%' }} />
);

export default EntityFieldSlotSpacer;
